import { JSXElement, mergeProps } from 'solid-js';
import AdminPortalApiConnector from '~/api/AdminPortalApiConnector.tsx';
import { ConfirmModalProvider } from '~/components/ui/Modal';
import PortalAuthentication from '~/components/AppContainer/PortalAuthentication.tsx';
import PortalCustomizations from '../../portal-customization/PortalCustomizations.tsx';
import NeedHelpContextProvider from '~/components/Layout/NeedHelp/NeedHelpContext.tsx';

type PortalContextProviderProps = {
  children: JSXElement;
};

export default function PortalContainer(
  props: PortalContextProviderProps
): JSXElement {
  const merged = mergeProps({}, props);

  return (
    <AdminPortalApiConnector>
      <PortalAuthentication>
        <NeedHelpContextProvider>
          <PortalCustomizations>
            <ConfirmModalProvider>{merged.children}</ConfirmModalProvider>
          </PortalCustomizations>
        </NeedHelpContextProvider>
      </PortalAuthentication>
    </AdminPortalApiConnector>
  );
}
